import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { ConfirmationDialog, CONFIRMATION_TYPES } from 'shared/UI/ConfirmationDialog'
import { Button, BUTTON_SIZES, BUTTON_TYPES, BUTTON_STYLES } from 'shared/UI/Button'
import { PreviewItem } from 'App/components/Items/Actions/PreviewItem'
import { ItemDialog } from 'App/components/Items/ItemDialog'

import './style.css.scss'

const IdenticalItemDialog = (props) => {
  let confirmAction, cancelAction
  const container = document.createElement('div')
  container.className = 'identical-item-dialog-container'

  if (props.allowReplaceDuplicateWithExisting) {
    confirmAction = props.onUseExisting
    cancelAction = props.onUseNew
  } else {
    confirmAction = () => handleError()
    cancelAction = props.onUseNew
  }

  const handleError = () => {
    const error = new Error('Cancel upload file')
    error.details = props.existingItemData
    props.onError(error)
  }

  const handlePreviewItem = () => {
    const dialogContainer = document.createElement('div')
    const dialogConfig = {
      dialogClass: 'preview-item-dialog',
      renderFunction: () => (
        <PreviewItem
          contentItemId={props.existingItemData.content_item_id}
          onClose={() => dialogContainer.remove()} />
      )
    }
    const dialogElement = <ItemDialog dialogConfig={dialogConfig} onClose={() => container.remove()} />
    document.body.appendChild(dialogContainer)
    ReactDOM.render(dialogElement, dialogContainer)
  }

  const element = (
    <ConfirmationDialog
      confirmationType= {CONFIRMATION_TYPES.info}
      confirmLabel='Use Existing'
      cancelLabel='Upload File'
      onConfirm={() => confirmAction()}
      onCancel={() => {
        container.remove()
        cancelAction()
      }}
      header='Duplicate Content Detected'
      title='The content you are trying to upload already exists.'
      subtitle='We recommend using the existing item to avoid duplicates.'
      message={
        <div>
          <div>{props.existingItemData.title}</div>
          <Button
            onClick={handlePreviewItem}
            size={BUTTON_SIZES.small}
            type={BUTTON_TYPES.primaryText}
            style={[BUTTON_STYLES.flat]}>
            Preview Item
          </Button>
        </div>
      }
      onClose={() => container.remove()}/>
  )

  document.body.appendChild(container)
  ReactDOM.render(element, container)
}

IdenticalItemDialog.propTypes = {
  existingItemData: PropTypes.object.isRequired,
  allowReplaceDuplicateWithExisting: PropTypes.bool.isRequired,
  onUseExisting: PropTypes.func.isRequired,
  onUseNew: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
}

export default IdenticalItemDialog
